import CreateProduct from "@features/products/pages/create-product";
import EditProduct from "@features/products/pages/edit-product";
import Products from "@features/products/pages/products";
import ProductList from "@features/products/components/ProductList";
import ImportProducts from "@features/products/components/ImportProducts";
import ProductDetailsPage from "@features/products/pages/product-details";
import StockAnalytics from "@features/products/pages/stock-analytics";
import EnhancedStockManagement from "@features/products/pages/enhanced-stock-management";
import StockHistoryPage from "@features/products/pages/stock-history";
import { ProductSelectDemo } from "@features/products/components/ProductSelectDemo";
export const productsRoutes = {
  path: "/products",
  element: <Products />,
  children: [
    {
      path: "/products",
      element: <ProductList />,
    },
    {
      path: "/products/create",
      element: <CreateProduct />,
    },
    {
      path: "/products/import",
      element: <ImportProducts />,
    },
    {
      path: "/products/select-demo",
      element: <ProductSelectDemo />,
    },
    {
      path: "/products/stock-analytics",
      element: <StockAnalytics />,
    },
    {
      path: "/products/enhanced-stock-management",
      element: <EnhancedStockManagement />,
    },
    {
      path: "/products/:id/view",
      element: <ProductDetailsPage />,
    },
    {
      path: "/products/:id/edit",
      element: <EditProduct />,
    },
    {
      path: "/products/:id/stock-history",
      element: <StockHistoryPage />,
    },
  ],
};
